import CategoryInfoForm from "./CategoryInfoForm";

export default function CategoryForm({ row: categoryRow, onEdit, onCreate }) {
  return <CategoryInfoForm category={categoryRow} onEdit={onEdit} onCreate={onCreate} />;
}
